import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("efaa_dash_User_Id"),
        token: localStorage.getItem("efaa_dash_Token"),
        usertype: localStorage.getItem("efaa_dash_User_Type"),
        name: localStorage.getItem("efaa_dash_User_name"),
        image: localStorage.getItem("efaa_dash_userImg"),
        phone: localStorage.getItem("efaa_dash_userPhone"),
        email: localStorage.getItem("efaa_dash_userEmail"),
        gender: localStorage.getItem("efaa_dash_userGender"),
        // permissions: localStorage.getItem("efaa_dash_permissions"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
